import type {
  FullQuoteItemMap,
  MultipleFullQuoteMap,
  Product,
  Project,
} from '@customink/project-service-react-components';
import { getSummarySubTotals } from '@customink/project-service-react-components';
import Big from 'big.js';

type buildEcommObjectProps = {
  groupedQuote?: MultipleFullQuoteMap;
  itemizedQuote?: FullQuoteItemMap;
  products?: Product[];
  project?: Project;
  voucherCode?: string;
};

export const buildEcommObject = ({
  groupedQuote,
  itemizedQuote,
  products,
  project,
  voucherCode,
}: buildEcommObjectProps) => {
  const items = project?.items?.map((item, index) => {
    const product = products?.find((product) =>
      product.colors.find((color) => color.id === item.product?.colorId),
    );
    const color = product?.colors.find(
      (color) => color.id === item.product?.colorId,
    );

    const itemId = item?.id || '';
    const unitPrice = itemId ? itemizedQuote?.[itemId]?.unit_price : '0.00';

    const quantity = item?.sizesQuantities?.reduce((acc, curr) => {
      return acc + (curr?.quantity || 0);
    }, 0);

    return {
      item_id: color?.id,
      item_name: product?.name,
      affiliation: 'external core',
      index,
      item_brand: product?.manufacturer,
      item_category3: product?.primary_category_name,
      item_variant: color?.name,
      price: Big(unitPrice || 0).toFixed(2),
      quantity: quantity,
    };
  });

  const subTotalPrice = groupedQuote
    ? getSummarySubTotals(groupedQuote)
    : '0.00';

  return {
    currency: 'USD',
    value: subTotalPrice,
    items: items,
    coupon: voucherCode,
  };
};
